/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { Container, AntdTable } from './Style';
import { TableShimmer } from './TableShimmer';

export default function TripHistoryRCTable(props) {
	const {
		dispatchAction,
		columns = [],
		hasPagination = true,
		pagination: paginationConfig,
		configs = {},
		togglePaginate = [{}, () => null],
		tableDatas = [{}, () => null],
		rowClassName,
	} = props;

	const [isLoading, setIsLoading] = useState(false);
	const dispatch = useDispatch();
	const [rowData, setRowData] = tableDatas;
	const [paginateConfig, setpaginateConfig] = togglePaginate;

	// Table onchange event
	const handleChange = (pagination, filters, sorter, rest) => {
		if (hasPagination) {
			const pageoffset = pagination.current * pagination.pageSize - pagination.pageSize;
			const resetSort = rest?.action === 'sort';
			const resetPaginate = Number(paginateConfig.limit) !== pagination.pageSize;
			const sendAscDesc = sorter?.column
				? sorter?.order === 'ascend'
					? 'ASC'
					: 'DESC'
				: configs?.defaultSort;
			const sortField = !isEmpty(sorter?.column) ? sorter?.field : configs?.defaultsortField;

			// Clear old data immediately when pagination changes
			if (!resetSort) {
				setRowData({ rows: [], count: 0 });
			}

			setpaginateConfig((prev) => ({
				...prev,
				limit: resetSort ? Number(paginateConfig.limit) : pagination.pageSize,
				offset: resetSort || resetPaginate ? 0 : pageoffset,
				currentPage: resetSort || resetPaginate ? 1 : pagination.current, // Use pagination.current directly
				sort_column: sortField,
				sort_direction: sendAscDesc,
			}));
		}
	};

	// api call for getting the total data/Filter data
	useEffect(() => {
		if (dispatchAction && !isEmpty(paginateConfig)) {
			const { offset, limit, ...rest } = paginateConfig;

			// Clear old data before making new API call
			setRowData({ rows: [], count: 0 });
			setIsLoading(true);

			dispatch(
				dispatchAction({
					offset: Number(offset),
					limit: Number(limit),
					...rest,
					...(configs?.staticPayload || {}),
				})
			)
				.then((res) => setRowData(res))
				.catch((err) => {
					console.error('API call failed:', err);
					setRowData({ rows: [], count: 0 });
				})
				.finally(() => {
					setIsLoading(false);
				});
		}
	}, [dispatch, dispatchAction, paginateConfig]);

	return (
		<Container>
			<TableShimmer
				rowsCount={Number(paginateConfig?.limit) || 10}
				columns={columns}
				loading={isLoading}
			/>
			<AntdTable
				{...props}
				onChange={handleChange}
				pagination={{
					...paginationConfig,
					total: rowData?.count,
					showSizeChanger: true,
					current: Number(paginateConfig?.currentPage) || 1,
					pageSize: Number(paginateConfig?.limit) || 10,
					position: ['bottomRight'],
				}}
				columns={columns}
				dataSource={rowData?.rows?.slice(0, paginateConfig?.limit || 10) || 0}
				className={isLoading ? 'hide' : 'show'}
				rowClassName={rowClassName}
			/>
		</Container>
	);
}

TripHistoryRCTable.propTypes = {
	columns: PropTypes.array,
	dispatchAction: PropTypes.func,
	hasPagination: PropTypes.bool,
	pagination: PropTypes.object,
	configs: PropTypes.object,
	tableDatas: PropTypes.array,
	togglePaginate: PropTypes.array,
	rowClassName: PropTypes.func,
};
